<template>
    <div>
        <el-dialog :class="['link-picklist',themeClass]"
                   :close-on-click-modal="false"
                   :visible.sync="isVisible"
                   :title="title || '请选择'"
                   modal-append-to-body
                   @close="closeDialog"
                   append-to-body>

            <link-auto-table
                ref="table"
                :option="tableOption"
                @dblClick="onDbClick">
                <slot></slot>
            </link-auto-table>

            <!-- 弹出框确定与取消按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" size="small">{{$t('global.cancel')}}</el-button>
                <el-button type="primary" @click="onConfirm" size="small">{{$t('global.confirm')}}</el-button>
            </span>
        </el-dialog>

        <multi-inputbox
            v-show="isMulti"
            :size="size"
            @change="onMultiInputChg"
            :disabled="isDisabled"
            :tag-label-field="showKey"
            :placeholder="placeholder"
            v-model="multiInputItems"
            @icon-click="openDialog"
        ></multi-inputbox>
        <el-input
            v-show="!isMulti"
            :disabled="isDisabled"
            v-model="inputValue"
            :size="size"
            readonly
            :placeholder="placeholder"
            @keyup.native.delete="clearSelectedData">
            <i class="el-icon-search el-input__icon"
               style="cursor: pointer;"
               slot="suffix"
               @click="openDialog"> <!-- 禁用情况下禁止打开picklist -->
            </i>
        </el-input>
    </div>
</template>

<script>
/* eslint-disable no-underscore-dangle,no-prototype-builtins,no-undef */

/*
* 该picklist组件非通用组件，仅用来兼容 link-auto-table的组合查询项
* */

import themeClass from '@mixins/theme-class';
import multiInputbox from './multi-inputbox';
import {getFitRows} from "./index";

export default {
    name: 'link-picklist',
    components: {multiInputbox},
    mixins: [themeClass],
    data() {
        return {
            isVisible: false,
            isConfirming: false,
            multiInputItems: [],
            inputValue: '',
            tableOption: {},
            multiFiltersRaw: null
        };
    },
    inject: { // 获取父组件的provide
        elForm: {default: {}},
        elFormItem: {default: {}}
    },
    model: {
        prop: 'modelval',
        event: 'model-change'
    },
    props: {
        modelval: [Array, Object, String],
        /* 是否开启多选 */
        multi: {
            type: Boolean,
            default: false
        },
        /* link-auto-table配置 */
        option: {},
        /* 标题 */
        title: String,
        /* 是否展示 */
        show: Boolean,
        /* picklist是否可用 */
        disabled: Boolean,
        /* 输入框内的展示字段 */
        showKey: String,
        /* 选择的字段映射map,默认情况下 key -> value */
        pickMap: Object,
        /* 反转pickMap的映射关系 */
        reverseMap: Boolean,
        /* 输入框的尺寸大小 */
        size: {
            type: String,
            default: 'mini'
        },
        /* 输入框内的提示信息 */
        placeholder: {
            type: String,
            default: '请选择'
        },
        /* 当前选中内容 */
        selected: [Object, Array]
    },
    computed: {
        isMulti(){
            return this.multi;
        },
        isDisabled() {
            return this.disabled || this.elForm.disabled;
        }
    },
    watch: {
        show: {
            immediate: true,
            handler: function (val) {
                if(val){
                    this.openDialog();
                }else{
                    this.closeDialog();
                }
            }
        },
        modelval: {
            immediate: true,
            handler: function (val) {
                this.setInputValue(val);
            }
        }
    },
    methods: {
        /**
         * @method：initTableOption
         * @createdBy:HuangJian
         * @date:2019/1/25
         * @params：
         * @description：初始化 link-auto-table
         */
        initTableOption(){
            var options = new AutoOption(this.option._initOption || {});
            options.storeFilterButton = false
            if(options){
                options.singleSelect = !this.multi;
                if(options._loadDefaultOption){
                    options._loadDefaultOption();
                }

                /*自定义页面高度，自动计算显示行数*/
                if (options.showNum == null) {
                    const fitRows = getFitRows()
                    options.fillRows = fitRows[0]
                    this.$set(options.param, 'rows', fitRows[0])
                    if (!options.sizeOption) {
                        options.sizeOption = fitRows
                    }
                }

            }
            options.beforeLoad = (config) => {
                const params = config.param;
                if(this.multiFiltersRaw){
                    if(params.filtersRaw){
                        params.filtersRaw.push(this.multiFiltersRaw);
                    }else{
                        params.filtersRaw = [this.multiFiltersRaw];
                    }
                }
            };
            options.updateable = false;
            options.insertable = false;
            options.copyable = false;
            options.selectCache = true;
            options.bodyRowHeight = 32;
            this.tableOption = options;
        },
        /**
         * @method：setInputValue
         * @createdBy:HuangJian
         * @date:2019/1/26
         * @params：
         * @description：设置输入框的值
         */
        setInputValue(val){
            if (this.isMulti) {
                this.multiInputItems = Array.isArray(val) ? val : [];
            } else {
                this.inputValue = val || '';
            }
        },
        /**
         * @method：onMultiInputChg
         * @createdBy:HuangJian
         * @date:2019/1/22
         * @params：
         * val：
         * @description：响应多选输入框的change事件
         */
        onMultiInputChg(val) {
            this.$emit('change', val);
            this.$emit('model-change', val);
            this.$emit('update:selected', val);
        },
        /**
         * @method：onClear
         * @createdBy:HuangJian
         * @date:2019/1/24
         * @params：
         * @description：输入框清空时触发
         */
        onClear(){
            const inputValue = this.isMulti ? [] : '';
            const changeValue = this.isMulti ? [] : {};
            this.$emit('change', changeValue);
            this.$emit('model-change', inputValue);
            this.$emit('update:selected', changeValue);
        },
        /**
         * @method：getSelected
         * @createdBy:HuangJian
         * @date:2019/1/24
         * @params：
         * @description：获取当前所选项
         */
        getSelected(){
            return this.$refs.table.getSelected();
        },
        /**
         * @method：closeDialog
         * @createdBy:HuangJian
         * @date:2019/1/24
         * @params：
         * @description：关闭弹窗
         */
        closeDialog(){
            this.$emit('update:show', false);
            this.isVisible = false;
            if(this.$refs.table) this.$refs.table.unselectAll();
        },
        /**
         * @method：openDialog
         * @createdBy:HuangJian
         * @date:2019/1/24
         * @params：
         * @description：打开弹窗
         */
        openDialog(){
            if(this.isDisabled) return;
            this.isConfirming = false;
            this.isVisible = true;
            var map = this.getMap();
            if(this.isMulti){
                var idStrs = [];
                this.multiInputItems.forEach((item) => {
                    if(item.hasOwnProperty('id') && item.id){
                        idStrs.push(item.id);
                    }else if(map && map.hasOwnProperty('id')){
                        if(item.hasOwnProperty(map.id) && item[map.id]){
                            idStrs.push(item[map.id]);
                        }
                    }
                });
                if(idStrs.length){
                    this.multiFiltersRaw = {
                        id: 'id_119',
                        property: 'id',
                        operator: 'not in',
                        value: '['+idStrs+']'
                    };
                }else{
                    this.multiFiltersRaw = null;
                }
                this.tableOption.list =[];
                this.tableOption.reload();
            }
        },
        /**
         * @method：onDbClick
         * @createdBy:HuangJian
         * @date:2019/1/25
         * @params：
         * @description：双击记录时触发
         */
        onDbClick(){
            if(!this.isMulti){
                this.onConfirm();
            }
        },
        /**
         * @method：getMap
         * @createdBy:HuangJian
         * @date:2019/2/14
         * @params：
         * @description：获取映射map
         */
        getMap(){
            var map = this.pickMap;
            if(this.reverseMap){
                var newMap = {};
                for(var k in map){
                    newMap[map[k]] = k;
                }
                map = newMap;
            }
            return map;
        },
        /**
         * @method：onConfirm
         * @createdBy:HuangJian
         * @date:2019/1/24
         * @params：
         * @description：双击记录、点击确定时触发
         */
        onConfirm() {
            if (this.isConfirming) {
                return;
            }
            this.isConfirming = true;

            /* 选择的数据 */
            var data = this.getSelected() || {};

            /* 根据pickMap转化后的数据 */
            var mappedData = null;

            /* 根据pickMap转化 */
            if (this.pickMap) {
                var list = Array.isArray(data) ? data : [data];
                var map = this.getMap();
                mappedData = [];
                list.forEach((row) => {
                    var tmp = linkTools.copyObjByMap(row, map) || null;
                    if (tmp !== null) {
                        mappedData.push(tmp);
                    }
                });
                if (!mappedData.length) {
                    /* 无有效数据 */
                    mappedData = null;
                } else {
                    mappedData = Array.isArray(data) ? mappedData : mappedData[0];
                }
            }

            /* 最终需要的数据 */
            var result = mappedData ? mappedData : data;

            /* 输入框样式的model处理 */
            var inputResult = null;
            var modelResult = null;

            if (this.isMulti) {
                inputResult = this.multiInputItems = this.multiInputItems.concat(result);
            } else {
                const key = this.showKey;
                if (result.hasOwnProperty(key)) {
                    inputResult = result[key];
                } else {
                    inputResult = data[key] || '';
                }
                this.inputValue = inputResult;
            }

            this.$emit('model-change', inputResult || modelResult);
            this.$emit('change', result);
            this.$emit('update:selected', result);
            this.closeDialog();
        }
    },
    mounted(){
        this.initTableOption();
    }
};
</script>

<style lang="scss">
    .link-picklist {
        overflow: hidden;
        .el-dialog {
            width: 50vw;
            margin-top: 50vh!important;
            transform: translateY(-50%);
            max-height: initial!important;
            max-width: initial!important;
            .el-dialog__body{
                padding: 0!important;
                /*max-height: initial!important;*/
                /*background: #F4F6FC!important;*/
            }
            .link-auto-table {
                .link-auto-table-filter{
                    background: #FFF;
                }
				.link-auto-table-header{
					padding: 8px 16px;
				}
                .link-auto-table-header-button-wrapper{
                    display: none!important;
                }
                .link-auto-table-content .link-auto-table-shadow .link-auto-table-shadow-content{
                    height: 100%;
                }
                .link-auto-table-footer {
                    border: none !important;
					padding: 8px 16px;
                }
                .link-auto-table-title {
                    display: none;
                }
            }
        }
    }
</style>
